// extracted by mini-css-extract-plugin
export default {"summary-container":"ProductReportSummary_summary-container__rWfoz","summary-ctas":"ProductReportSummary_summary-ctas__8W+3a"};